'use strict';

var util = angular.module('gymsystem.util');

util.directive('upcomingresourcebookings', ['$rootScope', '$interval', function($rootScope, $interval) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            var updateEndTime = function() {
                if (!$scope.settings || !$scope.config.control) { return; }
                var hoursAhead = $scope.settings.hoursAhead;
                var endTime = null;
                if (hoursAhead) {
                    endTime = new Date().addMinutes(60 * hoursAhead);
                } else {
                    endTime = new Date().addDays(1);
                }
                $scope.config.api.args.endTime = endTime.dateTime();
            };

            var updateStartTime = function() {
                if (!$scope.settings || !$scope.config.control) { return; }
                var minutesBefore = $scope.settings.minutesBefore;
                var startTime = null;
                if (minutesBefore) {
                    startTime = new Date().addMinutes(-1 * minutesBefore);
                } else {
                    startTime = new Date().addMinutes(-10);
                }
                $scope.config.api.args.startTime = startTime.dateTime();
            };

            var updateTimeInterval = function() {
                updateStartTime();
                updateEndTime();
                $scope.config.control.updateApi();
            };

            var updateTimePromise;

            $scope.config = {
                api: {
                    url: '/api/resourcebooking/get/booked',
                    args: {
                        startTime: (($scope.settings && $scope.settings.minutesBefore) ? new Date().addMinutes(-1 * $scope.settings.minutesBefore).dateTime() : new Date().addMinutes(-10).dateTime()),
                        endTime: (($scope.settings && $scope.settings.hoursAhead) ? new Date().addMinutes(60 * $scope.settings.hoursAhead) : new Date().addDays(1)).dateTime(),
                        category: $scope.settings?.category
                    },
                    transform: $rootScope.transformResourceBooking,
                    triggers: [{type: 'resourcebooking'}]
                },
                itemFilter: function(rb) {
                    if (!$scope.settings.showMine) { return true; }
                    var staff_id = $rootScope.currentStaff.id;
                    return rb.user_id == staff_id || rb.staff_id == staff_id || rb.xstaff_id == staff_id;
                },
                orderColumn: 'time',
                countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
                searchDepth: 2,
                rowClick: $rootScope.showRBooking,
                columns: [
                    {field: 'user.image', src: function(rb) { return $rootScope.smallMemberImage(rb.user); } },
                    {field: 'user.name', title: 'Name' },
                    // This column is only visible when displayAttendance is active
                    {field: 'present', title: 'Present', format: 'bool', visible: () => $scope.settings.displayAttendance },
                    {field: 'paid', title: 'Paid', format: 'bool' },
                    {field: 'service.name', title: 'Service' },
                    {field: 'staff.name', title: 'Resource' },
                    {field: 'time', title: 'Time', format: 'datetime' },
                ]
            };

            updateTimePromise = $interval(updateTimeInterval, 60000);

            $scope.$on('destroy', function() {
                if (angular.isDefined(updateTimePromise)) {
                    $interval.cancel(updateTimePromise);
                    updateTimePromise = undefined;
                }
            });
        }
    };
}]);
